import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, Navigate, useNavigate } from "react-router-dom";
import toastr from "../elements/toast";
import * as Yup from "yup";
import httpApiCall from "../../service/api.service";
import {
  clearPartnerStorage,
  getMd5Hash,
  getStorageValue,
  setLoginData,
  setStorageKey,
} from "../../service/shared.service";
import { useState } from "react";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import "./login.scss";
// import Register from '../register/register.lazy';
// import App from '../../App';
import {
  companyLogo,
  eyeIconHide,
  eyeIconShow,
  question,
} from "../../assets/assets";
import NewPassword from "./NewPassword";
import Spinner from "react-bootstrap/Spinner";

const LoginPage = () => {
  const [signup, setSignup] = useState(1);
  const [loggedin, setLoggedin] = useState(false);
  const [sppiner, setSppiner] = useState(false);
  const [imageState, setImageSrc] = useState({
    imgSrc: eyeIconHide,
    showPwd: true,
  });
  const [signIn, setSignIn] = useState({
    email: "",
    password: "",
  });

  const toastrService = new toastr(true);
  const SignupSchema = Yup.object().shape({
    password: Yup.string()
      .min(2, "Password is too Short!")
      .max(70, "Password is too Long!")
      .required("Please enter password"),
    email: Yup.string().email("Invalid email").required("Please enter valid email"),
    // newPassword: Yup.string()
    //     .min(2, 'Too Short!')
    //     .max(70, 'Too Long!').required('Please enter password').matches(
    //         /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    //         "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    //     ),
    //     confirmPassword: Yup.string()
    //     .min(2, 'Too Short!')
    //     .max(70, 'Too Long!').required('Please enter password').matches(
    //         /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
    //         "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    //     )
  });
  const navigate = useNavigate();
  const loginRedirect = (e: any) => {
    if (e == 2) {
      setSignup(2);
    } else if (e == 3) {
      navigate("/register");
    }
  };

  const goBack = () => {
    setSignup(1);
  };
  const updateImage = () => {
    const src = !imageState.showPwd ? eyeIconHide : eyeIconShow;
    setImageSrc({
      imgSrc: src,
      showPwd: !imageState.showPwd,
    });
  };

  const handleSubmit = async (getData: any) => {
    setSignIn(getData);
    setSppiner(true);

    // if (!getData.email || (getData.email && !getData.email.trim())) {
    //     toastrService.showError('Please enter valid email');
    //     return;
    // }
    // if (!getData.password || (getData.password && !getData.password.trim())) {
    //     toastrService.showError('Please enter valid password');
    //     return;
    // }

    const body = {
      partner_email: getData.email.replace(/\s/g, "").toLowerCase(),
      partner_password: getMd5Hash(getData.password),
    };
    await httpApiCall({ api: "email_login", type: "post", body })
      .then((data) => {
        setSppiner(false);
        // console.log(data);
        if (data.user_partner_info && data.user_partner_info.pu_id && data.user_partner_info.reset_password_token) {
          setStorageKey("user_info_data", {
            access_token: data.access_token,
            pu_id: data.user_partner_info.pu_id
          });
          setStorageKey("reset_password_token", data.user_partner_info.reset_password_token);
          // setStorageKey("reset_email", body.partner_email);
          // setStorageKey("pu_id", data.user_partner_info.pu_id);
          // setLoginData(data, 1, false);
          setSignup(4);
          return
        }
        if (data.flag == 116) {
          setStorageKey("reset_password_token", data.reset_password_token);
          setStorageKey("reset_email", body.partner_email);
          if (data && data.reset_password_token) {
            setSignup(4);
          }
          // redirect to new password html
        } else if (data && !data.is_error) {
          clearPartnerStorage();
          setLoginData(data, 1);
          handleLoggedIn();
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in SignIn:", error);
      });
  };


  const handleLoggedIn = () => {
    if (getStorageValue("partnerToken")) {
      setLoggedin(true);
    }
  };
  return (
    <>
      {!loggedin && !getStorageValue("partnerToken") ? (
        <div className="login">
          <div className="login_flow container">

            <div className="login_flow_start_left">
              <div className="flow-left">
                <img
                  src={companyLogo}
                  alt="App Logo"
                  className="img-responsive img-logo"
                />
                <div className="start-journey">
                  <span>Start your journey with us</span>
                </div>
                {signup == 2 ? (
                  <div className="back" onClick={goBack}>
                    <p>
                      <span>Back to</span> Log In
                    </p>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="login_flow_start_right">
              {signup == 1 && (
                <div className="flow-right">
                  <div className="signUp">
                    <p className="signUp_up">Sign In</p>
                    <p className="signUp_portal">
                      Enter your partner portal credentials
                    </p>
                  </div>
                  <div className="sign_form">
                    <Formik
                      initialValues={signIn}
                      onSubmit={handleSubmit}
                      validationSchema={SignupSchema}
                    >
                      <Form>
                        <div className="grouping">
                          <label htmlFor="" className="labels_input">
                            Email
                          </label>
                          <Field
                            type="email"
                            className="grouping_groups"
                            name="email"
                            translate="no"
                            id="email"
                            // autoComplete="off"
                          />
                          <small className="text-danger m-2">
                            <ErrorMessage name="email" />
                          </small>
                        </div>
                        <div className="grouping">
                          <div className="grouping_password">
                            <label htmlFor="" className="labels_input">
                              Password
                            </label>
                            <p
                              className="loginLinks"
                              onClick={() => loginRedirect(2)}
                            >
                              Forgot Password?
                            </p>
                          </div>
                          <div className="">
                            <div className="hide_show">
                              <Field
                                type={imageState.showPwd ? "password" : "text"}
                                className="grouping_groups"
                                name="password"
                                translate="no"
                                autoComplete="off"
                                id="password"
                            />
                              <img
                                className="eye-icon IMG"
                                alt="icon"
                                onClick={() => {
                                  updateImage();
                                }}
                                src={imageState.imgSrc}
                              />
                            </div>
                            <small className="text-danger m-2">
                              <ErrorMessage name="password" />
                            </small>
                          </div>
                        </div>
                        <div>
                          <div className="button_chase">
                            <button id="signIn" disabled={sppiner} type="submit" className="loginBtn">
                              Sign In
                              {sppiner && (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )}
                            </button>
                            <div className="loginLinks">
                              <span>New to credee?</span>
                              <span id="loginRedirect" onClick={() => loginRedirect(3)}>
                                {" "}
                                Sign Up
                              </span>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              )}
              {signup == 2 && (
                <ForgotPassword onSubmitSuccess={() => setSignup(1)} />
              )}
              {signup == 4 && <NewPassword email={signIn} />}
            </div>
          </div>
          <div className="bottom-login--wrap">
            <div className="login_end">
              <p>
                Visit
                <Link to="https://www.credee.com" target="_blank">
                  {" "}
                  Credee.com{" "}
                </Link>
                to learn about benefits for being a partner with us
              </p>
            </div>
            <div className="login_help">
              <Link to="https://www.credee.com/support" target="_blank">
                <span>
                  <img src={question} alt="question" /> Help & support
                </span>
              </Link>
            </div></div>
        </div>
      ) : (
        <Navigate to="/app/dashboard" replace={true} />
      )}
    </>
  );
};
export default LoginPage;
